import React from 'react';

import { InfoIcon } from '../info-icon';

export type DefinitionListItemTitleProps = {
    title: string | React.ReactNode;
    tooltip?: string | React.ReactNode;
    labelId?: string;
    children?: React.ReactNode;
};

export const DefinitionListItemTitle: React.FC<DefinitionListItemTitleProps> = ({ title, tooltip, labelId }) => {
    return (
        <div>
            {title}
            {tooltip && <InfoIcon text={tooltip} labelId={labelId} tippyProps={{ appendTo: document.body }} />}
        </div>
    );
};
